import { Component, OnInit, ViewChild } from "@angular/core";
import { UserTimePipe } from "app/components/shared/UserTimePipe";
import { LoadingService } from "app/services/loading-service/loading.service";
import { ConfirmationService, SelectItem } from "primeng/api";
import { ClientService } from "../../../../../../rest/client.service";
import { Rest } from "../../../../../../rest/rest_client";
import { AuthenticationService } from "../../../../../../core/services/authentication/authentication.service";
import { I18nService } from "../../../../../../services/i18n/i18n.service";
import { NotificationsService } from "../../../../../../services/notifications-service/notifications.service";
import { RestExt } from "../../../../../../services/rest-client-extension";
import { EntityListComponent } from "../../../../../../components/entity-list/entity-list.component";
import { CompanyFormComponent } from '../company-form/company-form.component';
import { BillingaccountService } from "app/rest/billingaccount.service";
import { TranslateService } from '@ngx-translate/core';
import { ExcelService } from "app/services/excel-service/excel.service";

@Component({
    selector: 'app-company-list',
    templateUrl: './company-list.component.html',
    styleUrls: ['./company-list.component.css'],
    providers: [BillingaccountService, ConfirmationService, UserTimePipe, ExcelService],
    standalone: false
})
export class CompanyListComponent
    extends EntityListComponent<Rest.BillingAccount>
    implements OnInit {
    title: string = this.translateService.instant('navbar.clients');

    @ViewChild(CompanyFormComponent, { static: true }) editForms: CompanyFormComponent;

    disableSave: boolean;

    user: Rest.User;
    EnabledFilter: SelectItem[];
    client: Rest.Client;

    constructor(
        private billingaccountService: BillingaccountService,
        protected confirmationService: ConfirmationService,
        public notificationsService: NotificationsService,
        protected i18n: I18nService,
        authenticationService: AuthenticationService,
        protected loadingService: LoadingService,
        protected userTime: UserTimePipe,
        protected excelService: ExcelService,
        protected translateService: TranslateService
    ) {
        super(
            billingaccountService,
            confirmationService,
            notificationsService,
            i18n,
            authenticationService,
            loadingService,
            userTime,
            excelService
        );
        this.billingaccountService = billingaccountService;
    }

    ngOnInit() {
        super.ngOnInit();
        this.form = this.editForms;
        this.hasEntityFilters = true;
        /*Permissions */
        this.user = this.authenticationService.user;
        /** */

    }


    beforeLoad() {
        this.paginationRequest.filters["clientID"] = [this.authenticationService.user.client.id.toString()];//we only need to search for reports of type tax
        if (this.paginationRequest.filters.hasOwnProperty("disabled")) {
            this.paginationRequest.filters["disabled"] = this.paginationRequest.filters["disabled"][0].toString() == "true" ? ["false"] : ["true"];
        }
    }
    excelColumns = {};
    exportExcel() {
        this.setExcelColumns();
        let fileNameTitle = this.translateService.instant('tableManagement.companies.companiesManagement');
        super.exportExcelWithColumns(fileNameTitle, this.excelColumns);
    }
    setExcelColumns() {
        const name = (entity: any) => entity.name ?? ''
        const disabled = (entity: any) => entity.disabled ?? ''
        this.excelColumns = {
            [this.translateService.instant('general.name')]: { bindField: name },
            [this.translateService.instant('general.disabled')]: { bindField: disabled },
        }
    }

}
